<template>
  <div class="d-flex m-3 gap-2">

    <!-- Main Content -->
    <div class="w-75 d-flex flex-column gap-3">
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-1">Select</h4>
        <h5 class="text-gray-600 mb-2">Is a component that is used for selecting options based on an array, array of objects, or an object.</h5>

        <h5 class="mt-4 mb-2">How to Import</h5>
        <p class="text-gray-600">To import the Input component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2">yarn add @bit/dtt.uic.dt-select</code>
      </div>

      <SelectSample />
      <SelectSlots />

      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-2">Props</h4>
        <b-table striped bordered :items="propsItems" :fields="propsFields"></b-table>
      </div>
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-2">Events</h4>
        <b-table striped bordered :items="eventItems" :fields="eventFields"></b-table>
      </div>
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-2">Slots</h4>
        <b-table striped bordered :items="slotItems" :fields="slotFields"></b-table>
      </div>
    </div>
  </div>
</template>

<script>
import SelectSample from '@/components/local/Select/SelectSample'
import SelectSlots from '@/components/local/Select/SelectSlots'

export default {
  components: { SelectSample, SelectSlots },
  data () {
    return {
      propsFields: [
        { key: 'prop', tdClass: 'code-text' },
        { key: 'type', tdClass: 'code-text' },
        { key: 'default', tdClass: 'code-text' },
        { key: 'description' }
      ],
      propsItems: [
        { prop: 'id', type: 'String', default: 'null', description: 'Used to set the `id` attribute on the rendered content, and used as the base to generate any additional element IDs as needed' },
        { prop: 'options', type: 'Array', default: '[]', description: 'Used to set options for the select component' },
        { prop: 'placeholder', type: 'String', default: `''`, description: `Used to set value of the select's placeholder` },
        { prop: 'label', type: 'String', default: `''`, description: `Used to label the field` },
        { prop: 'description', type: 'String', default: `''`, description: `Used to set the description below the field` },
        { prop: 'value', type: 'Object', default: `''`, description: 'Used to set the value of the select.'},
        { prop: 'max', type: 'String', default: `'10'`, description: 'Sets the maximum items to be displayed on the dropdown list before it becomes scrollable'},
        { prop: 'showSearch', type: 'Boolean', default: `false`, description: 'Shows the search field on the dropdown list'},
        { prop: 'hideCheck', type: 'Boolean', default: `false`, description: 'Hides the check mark indicator on the selected option'},
        { prop: 'labelField', type: 'String', default: `'text'`, description: 'Used to set the label of the selected option.'},
      ],
      eventFields: [
        { key: 'event', tdClass: 'code-text' },
        { key: 'arguments' },
        { key: 'description' }
      ],
      eventItems: [
        { event: 'click', arguments: 'event - Click Event', description: 'Emitted when the user selects an option' },
      ],
      slotFields: [
        { key: 'slot', tdClass: 'code-text' },
        { key: 'description' }
      ],
      slotItems: [
        { slot: 'no-options', description: 'Slot to replace the default no option placeholder' },
        { slot: 'option', description: 'Slot to replace the option value' },
        { slot: 'input', description: 'Slot to replace the selected value' },
      ]
    }
  }
}
</script>
